import { LoadingSpiner } from '../../../../../components/LoadingSpinner';
import { PriceArchitectureForm } from './components';
import { usePriceArchitectureConfig } from './hooks/usePriceArchitectureConfig';

const SetupIpaPriceArchitecture = () => {
  const { values, isLoading, isSaving, setEnabled, setApplyPsychologicalPricing, reset, save } = usePriceArchitectureConfig();

  if (isLoading) {
    return <LoadingSpiner size="md" />;
  }

  return (
    <PriceArchitectureForm
      values={values}
      isSaving={isSaving}
      onEnabledChange={setEnabled}
      onApplyPsychologicalPricingChange={setApplyPsychologicalPricing}
      onCancel={reset}
      onSave={save}
    />
  );
};

export default SetupIpaPriceArchitecture;
